module.exports = __webpack_public_path__ + "static/img/top2.04bc441.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/top2.png
// module id = xL0s
// module chunks = 1